import { useEffect, useState } from 'react'

export const useDebounceValue = (inputValue: string, delay = 500) => {
  const [debouncedValue, setDebouncedValue] = useState<string>(inputValue)
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null)

  useEffect(() => {
    if (timeoutId) clearTimeout(timeoutId)

    const handler = setTimeout(() => {
      setDebouncedValue(inputValue)
    }, delay)

    setTimeoutId(handler)

    return () => {
      clearTimeout(handler)
    }
  }, [inputValue, delay])

  return debouncedValue
}
